import AppLogoIcon from './app-logo-icon';

export default function AppLogo() {
    return (
        <div className="flex min-w-0 items-center gap-2">
            <div className="flex size-8 shrink-0 items-center justify-center overflow-visible rounded-lg bg-background shadow-sm ring-1 ring-border">
                <AppLogoIcon className="block size-7 object-contain" />
            </div>
            <div className="grid min-w-0 flex-1 text-left group-data-[collapsible=icon]:hidden">
                <span className="truncate text-sm font-semibold leading-none">Balancia</span>
                <span className="mt-1 truncate text-[10px] uppercase tracking-[0.16em] text-muted-foreground">SSCA</span>
            </div>
        </div>
    );
}
